module.exports = __webpack_public_path__ + "img/plant-1.393b67b.png";